
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class JobSlide extends Vue {
  @Prop() title: string;
  @Prop() value: string;
  @Prop() icon: string;
  @Prop() span: string|number;
  @Prop() span_value: string|number;
  private readonly static_server = "https://static.ty-sb1.tayeh.ir/tayeh-panel/assets/icons/";
}
